module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("1")]), _vm._v(" William Dampier (Wikimedia Commons, CC 1.0)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("2")]), _vm._v(" Queen Anne (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("3")]), _vm._v(" Map of New Caledonia (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("4")]), _vm._v(" Map of the Isthmus of Darien and Panama (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("5")]), _vm._v(" The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Roebuck")]), _vm._v(" (Wikimedia Commons, public domain"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("6")]), _vm._v(" Dampier’s passage through the East Indies (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("7")]), _vm._v(" Charles Montagu, Earl of Halifax (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("8")]), _vm._v(" Captain Robert Knox (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("9")]), _vm._v(" Charles II of England and Scotland (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("10")]), _vm._v(" Dampier’s illustration of a fish, bat and bird (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("11")]), _vm._v(" Daniel (De) Foe (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("12")]), _vm._v(" Execution Dock (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("13")]), _vm._v(" Isabella Fitzroy (née Bennet), Lady Grafton, Countess Arlington (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("14")]), _vm._v(" Jamaica (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("15")]), _vm._v(" Spanish Galleon (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("16")]), _vm._v(" Sir John Houblon (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("17")]), _vm._v(" John Locke (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("18")]), _vm._v(" Jonathan’s Coffee House (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("19.")]), _vm._v(" James II of England, and VII of Scotland (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("20")]), _vm._v(" Brandenburg’s Navy at sea (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("21")]), _vm._v(" Admiral Sir George Rooke (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("22")]), _vm._v(" Dampier’s circumnavigation (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("23")]), _vm._v(" Captain Kidd’s house in New York (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("24")]), _vm._v(" Juan Fernandez (Wikimedia Commons, CC 1.0)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("25")]), _vm._v(" Punch teaches Jack Ketch how to hang (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("26")]), _vm._v(" Admiral Sir Cloudesley Shovell (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("27")]), _vm._v(" A slave compound in Guinea (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("28")]), _vm._v(" Mary of Modena (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("29")]), _vm._v(" King William (Wikimedia Commons, public domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Plates#p30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("30")]), _vm._v(" John Evelyn (Wikimedia Commons, public domain)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a26e5c08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Illustrations.vue
// module id = 75
// module chunks = 0